import type { Immutable } from "immer";
import React from "react";

/**
 * Native React port of the legacy ``cms/blocks/anchor-block.html`` (#33285).
 *
 * ``AnchorBlock`` is a ``RegexBlock`` whose value is the raw anchor-id string,
 * so the prop is a plain ``string`` (threaded straight through the shim as
 * ``value=value`` -- no block serialization). Reproduces the legacy
 * ``<span id="{{ value }}"></span>`` exactly.
 *
 * Single source of truth: the toolbox component map's ``anchor_block`` entry
 * imports and renders this ``AnchorBlock`` (DRY).
 */
export const AnchorBlock = (
    props: Immutable<{ value: string }>,
): React.JSX.Element => {
    return <span id={props.value}></span>;
};
